import { get, toString } from 'es-toolkit/compat';
import * as React from 'react';
import { FieldProps } from 'formik';

import { FormattedTextInput } from './FormattedTextInput';
import { TextInput } from './TextInput';

interface Props extends FieldProps {
  className?: string;
  label?: string;
  filter?: InputFilter;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
  prefix?: JSX.Element | string;
  postfix?: JSX.Element | string;
}

/**
 * @deprecated
 * Plase see TextField in the ui folder of your project
 * Use `FormikTextInput` to have a text input field in a formik based form. .
 *
 * ```js
 * import { FormikTextInput } from '.';
 * ```
 */
export class FormikTextInput extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { field, form, filter, onChange } = this.props;

    if (filter) {
      // we are skipping the formik event here because the wrong value will be sent to the validate function
      const modelValue = filter.parseViewValue(event.target.value);
      form.setFieldValue(field.name, toString(modelValue), true);
    } else {
      field.onChange(event);
    }

    if (onChange) {
      onChange(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { field, filter, form, onBlur } = this.props;

    if (filter) {
      // we are skipping the formik event here because the wrong value will be sent to the validate function
      const modelValue = filter.parseViewValue(event.target.value);
      form.setFieldValue(field.name, toString(modelValue), true);
      form.setFieldTouched(field.name);
    } else {
      field.onBlur(event);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      field,
      filter,
      form: { touched, errors },
      label,
      className,
      onChange,
      onBlur,
      postfix,
      prefix,
      ...restProps
    } = this.props;

    const hasError = !!(get(touched, field.name) && get(errors, field.name));

    if (filter) {
      return (
        <FormattedTextInput
          label={label}
          filter={filter}
          hasError={hasError}
          error={get(errors, field.name)}
          className={className}
          postfix={postfix}
          prefix={prefix}
          {...field}
          {...restProps}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
        />
      );
    }
    return (
      <TextInput
        label={label}
        hasError={hasError}
        error={get(errors, field.name)}
        className={className}
        postfix={postfix}
        prefix={prefix}
        {...field}
        {...restProps}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
